export default __webpack_public_path__ + "static/media/Complaint.685e4e12.svg";